export default {
  translation: {
    OpenApp: "فتح التطبيق",
    FAQ: "الأسئلة الشائعة",
    AboutUs: "من نحن",
    Tutorials: "الدروس التعليمية",
    Blog: "المدونة",
    MyPlansTitle: "باقاتي",
    MyPlansDescription:
      "يمكنك مشاهدة قائمة الباقات التي يمكنني تصميمها في هذا القسم. لاحظ أن هذه الباقات لم يتم إعدادها مسبقاً وهي مصممة بناءً على حالتك البدنية وهدفك. يمكنك أيضاً التواصل معي عبر زر الدردشة في ملفي الشخصي بعد تثبيت تطبيق رامبودي.",
    ExpertiseTitle: "خبرتي",
    AboutMeTitle: "نظرة عامة عني",
    DownloadApps: "تحميل التطبيق",
    DownloadApps_sharelink: "1. تحميل التطبيق",
    DownloadDescription: "",
    TutorialVideo: "دروس تعليمية",
    TutorialVideoDescription:
      "شاهد الفيديوهات التعليمية هنا للاستخدام الأفضل ومعرفة كيفية تصميم خطط التدريب.",
    CompanyDescription:
      "رامبودي هو منصة تواصل بين المدربين والمتدربين لتوفير خطة تدريب وتغذية مخصصة.",
    AllRightsReserved: "جميع الحقوق محفوظة 2019. شركة فروسا للتقنيات.",
    CompanyName: "شركة فروسا للتقنيات",
    Level: "خطوة",
    HowToApplyProgram: "كيف أتقدم بطلب للحصول على باقة؟",
    ApplyProgramLevel1: "تحميل تطبيق رامبودي",
    ApplyProgramLevel2: "البحث عن رقمي التعريفي ({0}) في التطبيق",
    ApplyProgramLevel3: "التقدم بطلب لواحدة بناءً على احتياجاتك وأهدافك",
    ApplyProgramLevel4: "تصميم وإرسال الطلب خلال الوقت المحدد",
    Close: "إغلاق",
    ReadMore: "المزيد",
    Less: "أقل",
    experimental: "تجريبي",
    expert: "خبير",
    amateur: "هاوي",
    totalSentPlans: "إجمالي الخطط المرسلة",
    download: "تحميل رامبودي",
    requestPackage: "طلب خطة",
    info1: "2. التسجيل في التطبيق",
    info2: "3. العودة إلى هذه الصفحة",
    info3: "4. انقر على الزر أدناه",
    redirectingToApp: "محاولة فتح تطبيق رامبودي...",
    ifNotRedirected: "ليس لديك التطبيق؟ سنوجهك لتحميله قريباً.",
  },
};
